/**
 * Updates the recently viewed products in localStorage.
 *
 * GALPÓN (ago 2026) — todo acceso al storage va envuelto: el ACCESO A LA PROPIEDAD
 * `window.localStorage` LANZA `SecurityError` (DOMException 18) si el navegador deniega el
 * almacenamiento (cookies de terceros bloqueadas, privacidad estricta, WebView, iframe).
 * Esta es una feature de CONVENIENCIA y jamás debe tirar una excepción a la PDP:
 * `addProduct` se llama inline en un `<script type="module">` de scripts.liquid.
 * Caso real: Sentry SHOPIFY-GALPON-1R, 20-ago-2026. Sin storage simplemente no hay historial.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch {
      /* storage denegado o lleno: se pierde el historial, nada más */
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch {
      /* storage denegado: no hay nada que borrar */
    }
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }
}
